<template>
  <div class="systemFunction-container flex-box">
    <div class="title">{{ systemInfo.title }}</div>
    <div class="description">{{ systemInfo.description }}</div>
    <div class="systemFunction-list">
      <el-image
        class="preview-shot"
        fit="contain"
        :src="systemInfo.img"
        :preview-src-list="previewImgs"
      />
      <el-image
        class="img2 preview-shot"
        v-if="systemInfo.img2"
        fit="contain"
        :src="systemInfo.img2"
        :preview-src-list="previewImgs"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    systemInfo: {
      type: Object,
      default: () => {
        return {
          title: '',
          description: '',
          img: null,
          img2: null,
        }
      }
    },
  },
  computed: {
    previewImgs() {
      return [this.systemInfo.img, this.systemInfo.img2].filter(Boolean)
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.systemFunction-container {
  padding: 9rem 26rem 8.2rem;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 5rem;
  }

  .systemFunction-list {
    width: 100%;
    height: auto;
    border: .1rem solid #fff;
    img,
    ::v-deep .preview-shot {
      width: 100%;
      height: auto;
      display: block;
      cursor: zoom-in;
    }
    ::v-deep .preview-shot .el-image__inner {
      width: 100%;
      height: auto;
    }
    .img2 {
      margin-top: 6rem;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .systemFunction-container {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
}
</style>
